export default __webpack_public_path__ + "5db206b494a88f702a30b3224558cad7.svg";